import { httpClient } from "../../../http-client";
import { BuildingModel } from "../models/building.model";
import { FloorItemModel, FloorType } from "../models/floorItem.model";
import { ApiUrlBuilder } from "../../shared/constants/apiUrl";
import { getCause } from '../../../http-client/interceptors/error.interceptor';

export interface FloorItemView {
  id: string;
  name: string;
  type: FloorType;
  numberOfAnnotations: number;
  isGraphic: boolean;
}

export interface BuildingView {
  id: string;
  name: string;
  floors: FloorItemView[];
  isGraphic: boolean;
  isExported: boolean;
  address: string;
}

const BuildingServiceImplementation = {
  getBuilding: (orga: string, buildingId: string): Promise<BuildingModel> =>
    httpClient
      .get(ApiUrlBuilder.getBuilding(orga, buildingId))
      .then((response) => response.json())
      .then((response) => {
        const isBuildingView = (buildingView: any): buildingView is BuildingView =>
          "id" in buildingView && "name" in buildingView && "floors" in buildingView;
        if (isBuildingView(response)) {
          return new BuildingModel(
            response.id,
            response.name,
            response.floors.map((f) =>
              new FloorItemModel(f.id, f.name, f.type, f.numberOfAnnotations, f.isGraphic)
            ),
            response.isGraphic,
            response.isExported
          );
        } else {
          throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
        }
      }),
};

export const BuildingService: Readonly<typeof BuildingServiceImplementation> = BuildingServiceImplementation;
